import { NgModule } from '@angular/core';
import { RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MyProductsComponent } from './my-products.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { ScorecardsResolver } from 'shared/scorecard/scorecards.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';
import { ProductsPageGuard } from 'shared/product/products-page.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'my-products/:page',
        component: MyProductsComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard, ProductsPageGuard],
        data: { permissions: ['admin', 'catalog-view', 'catalog-edit', 'repository', 'fitments'] },
        resolve: {
          permissions: PermissionsResolver,
          scorecards: ScorecardsResolver,
        },
      },
      {
        path: 'my-products/:page/:searchId',
        component: MyProductsComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard, ProductsPageGuard],
        data: { permissions: ['admin', 'catalog-view', 'catalog-edit', 'repository', 'fitments'] },
        resolve: {
          permissions: PermissionsResolver,
          scorecards: ScorecardsResolver,
        },
      },
      {
        path: 'import-manager/:page/:searchId',
        component: MyProductsComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard],
        data: { permissions: ['admin', 'catalog-edit'] },
        resolve: { permissions: PermissionsResolver },
      },
      {
        path: 'export-manager/:page/:searchId',
        component: MyProductsComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard],
        data: { permissions: ['admin', 'catalog-edit', 'repository'] },
        resolve: { permissions: PermissionsResolver },
      },
      {
        path: 'my-products',
        redirectTo: 'my-products/working',
        pathMatch: 'full',
      },
    ])
  ],
  exports: [RouterModule],
})
export class MyProductsRoutingModule { }
